import { actions } from '../../actions/districtDetails';

const { SET_DISTRICT_DETAILS } = actions;

export default (state = {}, action) => {
    switch (action.type) {
        case SET_DISTRICT_DETAILS:
            return action.payload;
        default:
            return state;
    }
};
